var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{staticClass:"mx-auto mt-15",attrs:{"cols":"4"}},[_c('v-card',{staticClass:"py-15 text-center",attrs:{"flat":""}},[_c('h2',{staticClass:"green--text pb-2"},[_vm._v("Thank you.")]),_c('p',[_vm._v("You are now part of this game")])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }